// Base stylesheet needed for every page
import './scss/app.scss';

document.addEventListener("DOMContentLoaded", function() {
    require('./scripts/cookiesbakker');
});
